import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Affiliate, User } from '../../../_models';
import { AdvertiserAffiliateService, AdvertiserService, AuthenticationService, NotificationService, UserService } from '../../../_services';

@Component({
  selector: 'app-advertiser-affiliate-list',
  templateUrl: './affiliate-list.component.html'
})
export class AdvertiserAffiliateListComponent implements OnInit {
  advertiserId: string;
  advertiser: any = {};
  affiliates: Affiliate[];
  currentUser: User;
  loaded = false;
  loading = false;
  processing = false;
  itemsPerPage=  20;
  pagingList = [ 20, 40, 60, 80, 100 ];
  totalItems = 0;
  maxSize = 10;
  numPages = 0;
  currentPage = 1;
  emptyResult = false;
  showError = false;
  page: number;
  maxPageSize: number;

  filterable = {
    affiliate: null
  }

  constructor(
    private route: ActivatedRoute,
    private userSvc: UserService,
    private router: Router,
    private advertiserSvc: AdvertiserService,
    private affiliateSvc: AdvertiserAffiliateService,
    private notification: NotificationService,
    private authSvc: AuthenticationService) {

    this.currentUser = this.authSvc.currentUserValue;
  }

  ngOnInit(): void {
    this.advertiserId = this.route.snapshot.paramMap.get('id');
    this.loadDetail(this.advertiserId);
    this.loadPage();
  }

  private loadDetail(id){
    this.advertiserSvc.getAdvertiser(id).subscribe(data => {
      this.advertiser = data
    });
  }

  back() {
    this.router.navigate(['/dashboard/offer-stream/advertiser']);
  }

  deleteAffiliate(affiliate){
    if(confirm("Are you sure to delete this affiliate?")){
      this.affiliateSvc.deleteAffiliate(affiliate.id).subscribe(data => {
        if(data.status == 1){
          this.notification.showSuccess("Affiliate deleted successfully!", "Delete Affiliate");
          this.loadPage();
        }else{
          this.notification.showError("Error deleting affiliate, please try again later.", "Error");
        }
      })
    }
  }

  search(): void {
    this.totalItems = 0;
    this.loadPage(1);
  }

  setPage(pageNo: number): void {
    this.currentPage = pageNo;
    this.loadPage();
  }

  pageChanged(event: any): void {
    this.page = event.page;
    if(this.page != this.currentPage){
      this.loadPage(this.page);
    }
  }

  itemsPerPageChange(deviceValue) {
    this.itemsPerPage = deviceValue;
    this.loadPage(1);
  }

  private loadPage(page = null){
    this.loading = true;
    this.affiliates = [];
    let id = this.advertiserId;
    let params = {
      affiliate: this.filterable.affiliate,
      page: page == null ? this.currentPage - 1 : page - 1,
      pageSize: this.itemsPerPage || 20,
    }
    this.affiliateSvc.getAll(id, params).subscribe(data => {
      if(data !== null){
        this.affiliates = data.data.list;
        this.totalItems = data.data.total;
        this.currentPage = data.data.page + 1;
        this.maxPageSize = Math.ceil(data.data.total / data.data.pageSize) < 1 ? 1 : Math.ceil(data.data.total / data.data.pageSize);
        this.loaded = true;
        this.loading = false;
        this.emptyResult = false;
      }else{
        this.loading = false;
        this.emptyResult = true;
        this.notification.showWarning("There is no affiliate for this keyword.", "Empty Result");
      }
    });
  }

}
